import React, { useEffect, useRef } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Compact version for smaller spaces (e.g., in cards or sidebars)
const CompactStationMap = ({ station, height = "200px", className = "" }) => {
  if (!station || !station.lat || !station.lng) {
    return (
      <div className={`bg-gray-100 rounded flex items-center justify-center ${className}`} style={{ height }}>
        <p className="text-gray-500 text-sm">Location not available</p>
      </div>
    );
  }

  const createSimpleIcon = (maxPower) => {
    let color = '#10b981';
    if (maxPower >= 150) color = '#8b5cf6';
    else if (maxPower >= 50) color = '#f59e0b';
    else if (maxPower >= 22) color = '#3b82f6';

    const svgIcon = `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="${color}" width="25" height="25">
        <circle cx="12" cy="12" r="11" fill="white" stroke="${color}" stroke-width="2"/>
        <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" fill="${color}"/>
      </svg>
    `;

    return new L.DivIcon({
      html: svgIcon,
      iconSize: [25, 25],
      iconAnchor: [12.5, 12.5],
      className: 'compact-charging-marker'
    });
  };

  return (
    <div className={`rounded overflow-hidden border relative ${className}`} style={{ height }}>
      <MapContainer
        center={[station.lat, station.lng]}
        zoom={15}
        style={{ height: '100%', width: '100%' }}
        zoomControl={false}
        scrollWheelZoom={false}
        doubleClickZoom={false}
        dragging={false}
        touchZoom={false}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        <Marker
          position={[station.lat, station.lng]}
          icon={createSimpleIcon(station.max_power)}
        />
      </MapContainer>

      {/* Click overlay to open interactive map */}
      <div
        className="absolute inset-0 bg-transparent cursor-pointer z-20 flex items-center justify-center"
        onClick={() => {
          const url = `https://www.openstreetmap.org/?mlat=${station.lat}&mlon=${station.lng}&zoom=16`;
          window.open(url, '_blank');
        }}
      >
        <div className="bg-black bg-opacity-50 text-white px-2 py-1 rounded text-xs opacity-0 hover:opacity-100 transition-opacity">
          Click to open full map
        </div>
      </div>
    </div>
  );
};

export default CompactStationMap;
// Usage in station cards or compact views:
// <CompactStationMap station={station} height="150px" className="mb-4" />